// 结清证明申请和发送
import requestDefault from '@/shared/utils/request';
import { ContractPreviewType, SendEmailType } from './types';
import { ContractScene } from './enum';

/**
 * 开具结清证明
 * @param scene 开具类型（授信：01；提现：02）
 * @param loanOrderId 借贷订单号
 * @yapi https://yapi.hellobike.cn/project/3415/interface/api/324078
 */
export const getContractPreviewDetail = (scene: ContractScene, loanOrderId: string): Promise<ContractPreviewType> => requestDefault.postGate('f.contract.payOffCertificate', {
  scene,
  loanOrderId,
});

/**
 * 发送订单结清证明
 * @param toEmail 邮箱地址
 * @param loanOrderId 借贷订单号
 * @yapi https://yapi.hellobike.cn/project/3415/interface/api/324853
 */
export const sendToEmail = (
  toEmail: string,
  loanOrderId: string,
): Promise<SendEmailType> => requestDefault.postGate('f.contract.payoffCertificate.sendEmail', { toEmail, loanOrderId });

const ContractPreviewApi = {
  getContractPreviewDetail,
  sendToEmail,
};

export default ContractPreviewApi;
